"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = require("react");
var _reshowConstant = require("reshow-constant");
var _lazyInject = _interopRequireDefault(require("../lib/styles/lazyInject.js"));
var _injectStyle = _interopRequireDefault(require("../lib/styles/injectStyle.js"));
var _cleanStyleTag = _interopRequireDefault(require("../lib/styles/cleanStyleTag.js"));
var _genStyleId = _interopRequireDefault(require("../lib/styles/genStyleId.js"));
//@ts-check

/**
 * @param {object} InjectStyles
 * @param {object} existsInjection
 * @returns {object}
 */
var useLazyInject = function useLazyInject(InjectStyles, existsInjection) {
  var _useState = (0, _react.useState)(function () {
      return (0, _genStyleId["default"])("o");
    }),
    oid = _useState[0];
  /**
   * @type {any}
   */
  var injects = (0, _react.useRef)();
  var injectMounted = (0, _react.useRef)((0, _reshowConstant.NEW_OBJ)());
  var resetInject = function resetInject() {
    if (!injects.current) {
      if (!existsInjection) {
        existsInjection = (0, _lazyInject["default"])(InjectStyles, existsInjection);
      }
      injects.current = existsInjection;
    }
  };
  resetInject();
  (0, _react.useEffect)(function () {
    if (!(0, _reshowConstant.OBJ_SIZE)(injects.current)) {
      resetInject();
    }
    if (!(0, _reshowConstant.OBJ_SIZE)(injectMounted.current)) {
      (0, _injectStyle["default"])(injects.current);
    }
    injectMounted.current[oid] = true;
    return function () {
      delete injectMounted.current[oid];
      if (!(0, _reshowConstant.OBJ_SIZE)(injectMounted.current)) {
        (0, _cleanStyleTag["default"])(injects.current);
      }
    };
  }, []);
  return injects.current;
};
var _default = exports["default"] = useLazyInject;
module.exports = exports.default;